import { render, staticRenderFns } from "./Retail.vue?vue&type=template&id=d680c8a4&"
import script from "./Retail.vue?vue&type=script&lang=js&"
export * from "./Retail.vue?vue&type=script&lang=js&"
import style0 from "./Retail.vue?vue&type=style&index=0&media=all&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports